import {usePathname} from '@aboutyou/router';

export const useBrandShopPath = () => {
  const pathname = usePathname();

  return (categoryId?: number): string => {
    if (!categoryId) {
      return pathname;
    }

    return `${pathname}?category=${categoryId}`;
  };
};
